import { Navigation, Location, Outlet, useLocation, Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Loading from "../../Loading";

const RequireAuth = ({allowedRoles}) =>{
    const {auth, loading} = useAuth();
    // console.log('saurabh ', allowedRoles);
    const location = useLocation();

    if(loading)
        return <Loading />;

    const from = location.state?.from?.pathname
    // console.log("from", from);

    return (    
        //might have to fetch roles from token
        //auth?.roles?.map(role => allowedRoles?.include(role))
        allowedRoles?.includes(auth?.roles)
        ?<Outlet/>
        :auth?.accessToken
            ? <Navigate to="/unauthorized" state={{from: location}} replace/>
            :<Navigate to="/login" state={{from: location}} replace/>
    )
}

export default RequireAuth;